import React from 'react';
import './common.scss';
import { Button, Hidden } from '@material-ui/core';

function YellowButton(props) {

  const Btn = () => (
    <div className="yellow-button-container">
      <Button
        type={props.type}
        fullWidth
        variant="contained"
        className="button yellow"
        onClick={props.handleClick}
        disabled={!!props.disabled}
      >
        {props.title}
      </Button>
    </div>
  );

  if (!props.hidden) return <Btn />;

  return (
    <Hidden only={['sm', 'xs']}>
      <Btn />
    </Hidden>
  );
}

YellowButton.defaultProps = {
  type: 'button',
  hidden: true
};

export default YellowButton;
